<template>
    <section>
        <div v-if="show">

            <div>
                <b-modal :active="isModalCompositionByYearActive" aria-modal has-modal-card :destroy-on-hide="true" aria-role="dialog" width="100%"
                    :can-cancel="canCancel">
                    <template>
                        <ModalCompositionByYear modal-cancel="true" :minYear="minYear" :maxYear="maxYear" :unitId="unitId"
                            @close="isModalCompositionByYearActive = false" />
                    </template>
                </b-modal>

                <b-modal :active="isModalCompositionByQuartileActive" aria-modal has-modal-card :destroy-on-hide="true" aria-role="dialog" width="100%"
                    :can-cancel="canCancel">
                    <template>
                        <ModalCompositionByQuartile modal-cancel="true" :minYear="minYear" :maxYear="maxYear" :unitId="unitId"
                            @close="isModalCompositionByQuartileActive = false" />
                    </template>
                </b-modal>

                <b-modal :active="isModalCompositionByTypeDataBaseActive" aria-modal has-modal-card :destroy-on-hide="true" aria-role="dialog" width="100%"
                    :can-cancel="canCancel">
                    <template>
                        <ModalCompositionByTypeDataBase modal-cancel="true" :minYear="minYear" :maxYear="maxYear" :unitId="unitId"
                            @close="isModalCompositionByTypeDataBaseActive = false" />
                    </template>
                </b-modal>
            </div>

            <b-collapse v-if="showYears"
                :open="isOpenSummary" @open="isOpenSummary = true" class="card" animation="slide" aria-id="contentIdForA11y3">
                <template #trigger="props">
                    <div class="card-header" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
                        <p class="card-header-title is-centered">
                            Resumen Indicador Publicaciones en Revista
                        </p>
                        <a class="card-header-icon">
                            <b-icon :icon="props.open ? 'angle-down' : 'angle-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>
                <div class="card-content">
                    <div class="content">
                        <SummaryIndicatorPublication :total="total" />
                    </div>
                </div>
            </b-collapse>
            <br v-if="showYears">
            <b-collapse v-if="showYears" :open="isOpenYear" @open="isOpenYear = true" class="card" animation="slide" aria-id="contentIdForA11y3">
                <template #trigger="props">
                    <div class="card-header" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
                        <p class="card-header-title is-centered">
                            FING 32 - Cantidad de Publicaciones en Revista por Año
                        </p>
                        <a class="card-header-icon">
                            <b-icon :icon="props.open ? 'angle-down' : 'angle-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>
                <div class="card-content">
                    <div class="content">
                        <IndicatorByYear :years="indicatorFing32" :title="'publication_year'" />
                        <div class="columns is-centered my-4">
                            <div class="column has-text-centered">
                                <b-button label="Ver Composición" icon-left="shapes" type="is-primary"
                                    @click="isModalCompositionByYearActive = true" />
                            </div>
                        </div>
                    </div>
                </div>
            </b-collapse>
            <br v-if="showTypeQuartile">
            <b-collapse v-if="showTypeQuartile"
                :open="isOpenType" @open="isOpenType = true" class="card" animation="slide" aria-id="contentIdForA11y3">
                <template #trigger="props">
                    <div class="card-header" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
                        <p class="card-header-title is-centered">
                            FING 33 - Proporción de Publicaciones según Cuartil
                        </p>
                        <a class="card-header-icon">
                            <b-icon :icon="props.open ? 'angle-down' : 'angle-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>
                <div class="card-content">
                    <div class="content">
                        <IndicatorByType :types="indicatorFing33" :title="'Cuartiles'" />
                        <div class="columns is-centered my-4">
                            <div class="column has-text-centered">
                                <b-button label="Ver Composición" icon-left="shapes" type="is-primary"
                                    @click="isModalCompositionByQuartileActive = true" />
                            </div>
                        </div>
                    </div>
                </div>
            </b-collapse>
            <br v-if="showTypeDataBase">
            <b-collapse v-if="showTypeDataBase"
                :open="isOpenTypeBarDataBase" @open="isOpenTypeBarDataBase = true" class="card" animation="slide" aria-id="contentIdForA11y3">
                <template #trigger="props">
                    <div class="card-header" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
                        <p class="card-header-title is-centered">
                            FING 34 - Cantidad de Publicaciones Indexadas en Bases de Datos Wos, Scopus o Scielo
                        </p>
                        <a class="card-header-icon">
                            <b-icon :icon="props.open ? 'angle-down' : 'angle-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>
                <div class="card-content">
                    <div class="content">
                        <b-message type="is-warning" has-icon>
                            ¡Atención! Las Publicaciones en Revista pueden estar indexadas en más de una base de datos a la vez.
                        </b-message>
                        <IndicatorByTypeBar :types="indicatorFing34" :total="total" :title="'Bases de Datos'" />
                        <div class="columns is-centered my-4">
                            <div class="column has-text-centered">
                                <b-button label="Ver Composición" icon-left="shapes" type="is-primary"
                                    @click="isModalCompositionByTypeDataBaseActive = true" />
                            </div>
                        </div>
                    </div>
                </div>
            </b-collapse>
            <br>
        </div>
        <div v-else>
            <div class="columns is-centered">
                <div class="column is-6 is-centered has-text-centered">
                    <b-message has-icon type="is-warning">
                        <h1> No se encontraron resultados. Porfavor ingrese nuevas Publicaciones en Revista para mostrar sus indicadores.</h1>
                    </b-message>
                </div>
            </div>
        </div>

        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />

    </section>
</template>

<script>
import axios from 'axios'
import IndicatorByType from './indicator_by_type.vue'
import IndicatorByYear from './indicator_by_year.vue'
import IndicatorByTypeBar from './indicator_by_type_bar.vue'
// import IndicatorByTypePolarBar from './indicator_by_type_polar_bar.vue'
import SummaryIndicatorPublication from './summary_indicator_publication.vue'
import ModalCompositionByYear from './modal_composition_by_year_publication.vue'
import ModalCompositionByQuartile from './modal_composition_by_quartile_publication.vue'
import ModalCompositionByTypeDataBase from './modal_composition_by_type_data_base.vue'
export default {
    components: {
        IndicatorByType, IndicatorByYear, IndicatorByTypeBar, SummaryIndicatorPublication, ModalCompositionByYear, ModalCompositionByQuartile,
        ModalCompositionByTypeDataBase,
    },
    props: [
        'minYear', 'maxYear', 'unitId', 'changeFilter'
    ],
    data() {
        return {
            isOpenSummary: true,
            show: false,
            showYears: false,
            showTypeQuartile: false,
            showTypeDataBase: false,
            isOpenType: true,
            isOpenYear: true,
            isOpenTypeBarDataBase: true,
            isOpenTypeBarDataBasePolarBar: true,
            isLoading: false,
            total: 0,

            //Modals
            canCancel: ["escape"],
            isModalCompositionByYearActive: false,
            isModalCompositionByQuartileActive: false,
            isModalCompositionByTypeDataBaseActive: false,

            //Indicadores
            indicatorFing32: {
                years: [],
                series:[{
                    name: 'Total',
                    data: []
                }],
            },
            indicatorFing33: [],
            indicatorFing34: [],
        }
    },

    async created() {
        this.show = false
        await this.getIndicatorFing32()
        await this.getIndicatorFing33()
        await this.getIndicatorFing34()
        this.show = this.showYears || this.showTypeQuartile || this.showTypeDataBase
    },

    methods: {

        async getIndicatorFing32() {
            this.isLoading = true
            await axios
                .get('/dashboards/get-indicator-values-for-unit.json', {
                    params: {
                        unit_id: this.unitId,
                        minYear: this.minYear,
                        maxYear: this.maxYear,
                        indicator_code: 'fing32',
                    }
                })
                .then(response => {
                    this.indicatorFing32 = {
                        years: [],
                        series: [{
                            name: 'Total',
                            data: []
                        }],
                    }
                    this.total = 0
                    this.showYears = false

                    for (let index = 0; index < response.data.length; index++) {
                        let indicator_value = response.data[index]

                        this.indicatorFing32.years.push(String(indicator_value.year))
                        this.indicatorFing32.series[0].data.push(indicator_value.indicator_value)
                        this.total += indicator_value.indicator_value
                        this.showYears = this.showYears || (indicator_value.indicator_value > 0)
                    }
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }).finally(() => {
                    this.isLoading = false
                })
        },

        async getIndicatorFing33() {
            this.isLoading = true
            await axios
                .get('/dashboards/get-indicator-values-for-unit.json', {
                    params: {
                        unit_id: this.unitId,
                        minYear: this.minYear,
                        maxYear: this.maxYear,
                        indicator_code: 'fing33',
                    }
                })
                .then(response => {
                    this.indicatorFing33 = []
                    this.showTypeQuartile = false
                    let valueQuartile1 = 0
                    let valueQuartile2 = 0
                    let valueQuartile3 = 0
                    let valueQuartile4 = 0
                    let valueQuartileNone = 0

                    for (let index = 0; index < response.data.length; index++) {
                        let indicator_value = response.data[index]
                        if (indicator_value.type_id === 1) {
                            valueQuartile1 += indicator_value.indicator_value
                        } else if (indicator_value.type_id === 2) {
                            valueQuartile2 += indicator_value.indicator_value
                        } else if (indicator_value.type_id === 3) {
                            valueQuartile3 += indicator_value.indicator_value
                        } else if (indicator_value.type_id === 4) {
                            valueQuartile4 += indicator_value.indicator_value
                        } else if (indicator_value.type_id === null) {
                            valueQuartileNone += indicator_value.indicator_value
                        }
                    }

                    this.indicatorFing33.push({
                        name: 'Cuartil 1',
                        value: valueQuartile1
                    })

                    this.indicatorFing33.push({
                        name: 'Cuartil 2',
                        value: valueQuartile2
                    })

                    this.indicatorFing33.push({
                        name: 'Cuartil 3',
                        value: valueQuartile3
                    })

                    this.indicatorFing33.push({
                        name: 'Cuartil 4',
                        value: valueQuartile4
                    })

                    this.indicatorFing33.push({
                        name: 'No tiene Cuartil',
                        value: valueQuartileNone
                    })

                    this.showTypeQuartile = (valueQuartile1 > 0) || (valueQuartile2 > 0) || (valueQuartile3 > 0) || (valueQuartile4 > 0) || (valueQuartileNone > 0)

                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }).finally(() => {
                    this.isLoading = false
                })
        },

        async getIndicatorFing34() {
            this.isLoading = true
            await axios
                .get('/dashboards/get-indicator-values-for-unit.json', {
                    params: {
                        unit_id: this.unitId,
                        minYear: this.minYear,
                        maxYear: this.maxYear,
                        indicator_code: 'fing34',
                    }
                })
                .then(response => {
                    this.indicatorFing34 = []
                    this.showTypeDataBase = false
                    let valueScopus = 0
                    let valueScielo = 0
                    let valueWos = 0

                    for (let index = 0; index < response.data.length; index++) {
                        let indicator_value = response.data[index]
                        if (indicator_value.type_id === 1) {
                            valueScopus += indicator_value.indicator_value
                        } else if (indicator_value.type_id === 2) {
                            valueScielo += indicator_value.indicator_value
                        } else if (indicator_value.type_id === 3) {
                            valueWos += indicator_value.indicator_value
                        }
                    }

                    this.indicatorFing34.push({
                        name: 'Scopus',
                        value: valueScopus
                    })

                    this.indicatorFing34.push({
                        name: 'Scielo',
                        value: valueScielo
                    })

                    this.indicatorFing34.push({
                        name: 'Wos',
                        value: valueWos
                    })

                    this.showTypeDataBase = (valueScopus > 0) || (valueScielo > 0) || (valueWos > 0)

                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }).finally(() => {
                    this.isLoading = false
                })
        }

    },

    watch: {
        async changeFilter() {
            this.show = false
            await this.getIndicatorFing32()
            await this.getIndicatorFing33()
            await this.getIndicatorFing34()
            this.show = this.showYears || this.showTypeQuartile || this.showTypeDataBase
            deep: true
        },
    },


}
</script>